import { render, staticRenderFns } from "./customer-navegation.vue?vue&type=template&id=77f4d522&"
import script from "./customer-navegation.vue?vue&type=script&lang=js&"
export * from "./customer-navegation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports